import { format, parse, setHours, setMinutes } from "date-fns";

/**
 * Function transforming a given number to string in hour format (00:00). Used to parse absence request form data to BE friendly format.
 * @param {number} hour - number between 0 and 23.
 * @returns {string} string with hour format.
 */
export const parseHourFromTimeNumber = (hour: number) => {
  if (hour < 0 || hour > 23) {
    throw new Error("Hour must be between 0 and 23");
  }

  const date = new Date();
  const timeWithHour = setHours(date, hour);
  const timeWithMinutes = setMinutes(timeWithHour, 0);

  return format(timeWithMinutes, "HH:mm");
};

/**
 * Function transforming a given string in hour format (00:00:00) to number. Used to parse absence request data from API to numbers use in form.
 * @param {string} hour - string in format 00:00:00
 * @returns {number} number between 0 and 23.
 */
export const parseHourFromTimeString = (hour?: string) => {
  if (typeof hour !== "string") return 0;

  const date = parse(hour, "HH:mm:ss", new Date());

  return date.getHours();
};
